// extracted by mini-css-extract-plugin
export default {"room_wrap":"style_room_wrap__FpZSi","room_box":"style_room_box__QrVlN","active":"style_active__-eMFo"};